import PageTitle from '../components/PageTitle';

import Section from '../components/Section';
import { InlineClippedImage } from '../components/InlineClippedImage';

import White_Corner_9x12_300 from '../assets/images/content/White_Corner_9x12_300.jpg';
import the_whole_is_greater_than_the_sum from '../assets/images/the_whole_is_greater_than_the_sum.svg';
import Corner_Conference_9x12_300 from '../assets/images/content/Corner_Conference_9x12_300.jpg';

const ShareholderInformation = () => {
	function renderStaff(items) {
		return items.map((item, index) => (
			<div className="flex flex-col mb-8 break-inside-avoid-column" key={index}>
				<p className="my-0 font-bold">{item.name}</p>
				<p className="my-0 leading-[1.6]" dangerouslySetInnerHTML={{ __html: item.title }}></p>
				<p className="my-0 leading-[1.6]">{item.desc}</p>
				<p className="my-0 leading-[1.6]  text-[.85rem]" dangerouslySetInnerHTML={{ __html: item.footnote }}></p>
			</div>
		));
	}

	const directors = [
		{
			name: 'Philip Bleser',
			title: 'Retired Chairman of Global Corporate Banking,<br/> JPMorgan Chase & Co.',
			desc: '(financial services)',
			footnote: 'Audit Committee Member,<br/> Nominating and Governance Committee Member,<br/> Independent Director',
		},
		{
			name: 'Stuart B. Burgdoerfer',
			title: 'Retired Executive Vice President and Chief Financial Officer,<br/> L Brands, Inc.',
			desc: '(retailing)',
			footnote: 'Audit Committee Member,<br/> Technology Committee Member,<br/> Independent Director',
		},
		{
			name: 'Pamela J. Craig',
			title: 'Retired Chief Financial Officer,<br/> Accenture PLC',
			desc: '(global management consulting)',
			footnote: 'Compensation and Talent Committee Member,<br/>Technology Committee Member,<br/> Independent Director',
		},
		{
			name: 'Charles A. Davis',
			title: 'Chief Executive Officer,<br/> Stone Point Capital LLC',
			desc: '(private equity investing)',
			footnote: 'Investment and Capital Committee Member,<br/> Independent Director',
		},
		{
			name: 'Roger N. Farah',
			title: 'Executive Chair of the Board,<br/> CVS Health Corporation',
			desc: '(healthcare)',
			footnote: 'Executive Committee Member,<br/> Compensation and Talent Committee Member,<br/> Nominating and Governance Committee Member,<br/> Independent Director',
		},
		{
			name: 'Lawton W. Fitt',
			title: 'Chairperson of the Board,<br/> The Progressive Corporation & Retired Partner,<br/> Goldman Sachs Group',
			desc: '(financial services)',
			footnote: 'Executive Committee Member,<br/> Investment and Capital Committee Member,<br/> Nominating and Governance Committee Member,<br/> Independent Director',
		},
		{
			name: 'Susan Patricia Griffith',
			title: 'President and Chief Executive Officer,<br/> The Progressive Corporation',
			desc: '',
			footnote: 'Executive Committee Member',
		},
		{
			name: 'Devin C. Johnson',
			title: 'Former President,<br/> The SpringHill Company',
			desc: '(global consumer and entertainment)',
			footnote: 'Audit Committee Member, <br/>Technology Committee Member,<br/> Independent Director',
		},
		{
			name: 'Jeffrey D. Kelly',
			title: 'Retired Chief Operating Officer and Chief Financial Officer,<br/> RenaissanceRe Holdings Ltd.',
			desc: '(reinsurance services)',
			footnote: 'Audit Committee Member, <br/>Independent Director',
		},
		{
			name: 'Barbara R. Snyder',
			title: 'President,<br/> The Association of American Universities',
			desc: '(higher education)',
			footnote: 'Compensation and Talent Committee Member,<br/> Independent Director',
		},
		{
			name: 'Kahina Van Dyke',
			title: 'Operating Partner,<br/> Advent International',
			desc: '(global private equity)',
			footnote: 'Investment and Capital Committee Member,<br/> Technology Committee Member,<br/> Independent Director',
		},
	];

	const corporate = [
		{
			name: 'Lawton W. Fitt',
			title: 'Chairperson of the Board',
			desc: '(non-executive)',
			footnote: '',
		},
		{
			name: 'Susan Patricia Griffith',
			title: 'President and Chief Executive Officer',
			desc: '',
			footnote: '',
		},
		{
			name: 'John P. Sauerland',
			title: 'Vice President and Chief Financial Officer',
			desc: '',
		},
		{
			name: 'David M. Stringer',
			title: 'Vice President, Secretary,<br/> and Chief Legal Officer',
			desc: '',
			footnote: '',
		},
		{
			name: 'Allyson L. Bach',
			title: 'Assistant Secretary',
			desc: '',
			footnote: '',
		},
		{
			name: 'Carl G. Joyce',
			title: 'Vice President<br/> and Chief Accounting Officer',
			desc: '',
			footnote: '',
		},
		{
			name: 'Maureen McCoy Spooner',
			title: 'Treasurer',
			desc: '',
			footnote: '',
		},
	];

	const other = [
		{
			name: 'Karen B. Bailo',
			title: 'Commercial Lines President',
			footnote: '',
		},
		{
			name: 'Jonathan S. Bauer',
			title: 'Chief Investment Officer',
			footnote: '',
		},
		{
			name: 'Steven A. Broz',
			title: 'Chief Information Officer',
			footnote: '',
		},
		{
			name: 'Patrick K. Callahan',
			title: 'Personal Lines President',
			footnote: '',
		},
		{
			name: 'William L. Clawson II',
			title: 'Chief Human Resources Officer',
			footnote: '',
		},
		{
			name: 'John Murphy',
			title: 'Claims President',
			footnote: '',
		},
		{
			name: 'Lori Niederst',
			title: 'Customer Relationship Management President',
			footnote: '',
		},
		{
			name: 'Maribel Pumarejo',
			title: 'Chief Marketing Officer',
			footnote: '',
		},
		{
			name: 'Andrew J. Quigg',
			title: 'Chief Strategy Officer',
			footnote: '',
		},
	];

	return (
		<>
			<PageTitle title="Shareholder Information" />
			<div>
				<span className="block text-[0.85rem] leading-[0.89238rem] font-[300] px-6 py-6">As of November 3, 2025</span>
			</div>

			<div className="py-12 md:py-24">
				<div className="grid md:grid-cols-[1fr_1fr] gap-12 px-4 sm:px-6">
					<div className="grid order-2 md:order-1">
						<img src={White_Corner_9x12_300} alt="" className="md:max-w-[563px] my-auto mx-auto" />
					</div>
					<div className="md:max-w-[581px] order-1 md:order-2">
						<h2 className="heading-one text-[#4B7B9D] mb-6 mt-0">Directors</h2>
						<div className="gap-8 md:columns-2">{renderStaff(directors)}</div>

						<hr />

						<h3 className="heading-one text-[#4B7B9D] mb-6">Corporate Officers</h3>
						<div className="gap-8 md:columns-2">{renderStaff(corporate)}</div>

						<hr />

						<h3 className="heading-one text-[#4B7B9D] mb-6">Other Executive Officers</h3>
						<div className="gap-8 md:columns-2">{renderStaff(other)}</div>
					</div>
				</div>
			</div>
			<div className="container max-w-container-lg">
				<img src={the_whole_is_greater_than_the_sum} alt="the_whole_is_greater_than_the_sum" className="w-full opacity-20" />
			</div>
			<div className="py-24">
				<div className="md:grid grid-cols-[1fr_1fr] gap-12 px-4 sm:px-6">
					<div className="grid">
						<div className="md:max-w-[510px] ml-auto">
							<div className="flex flex-col gap-6">
								<div>
									<h3 className="heading-two text-[#F26721] m-0">Principal Office</h3>
									<p className="">
										The Progressive Corporation
										<br />
										300 North Commons Blvd.
										<br />
										Mayfield Village, Ohio 44143
										<br />
										440-461-5000
										<br />
										<a href="https://www.progressive.com/" target="_blank" rel="noreferrer" className="underline">
											progressive.com
										</a>
									</p>
								</div>
								<div>
									<h3 className="heading-two text-[#F26721] m-0">Annual Meeting</h3>
									<p className="">The Annual Meeting of Shareholders was held on Friday, May 9, 2025, at 10:00 a.m., eastern time. This meeting was held by online webcast only. There was no physical location for the meeting.</p>
								</div>
								<div>
									<h3 className="heading-two text-[#F26721] m-0">Online Annual Report and Proxy Statement</h3>
									<p className="">
										Our 2024 Annual Report to Shareholders can be found at:{' '}
										<a href="https://progressive.com/annualreport" target="_blank" rel="noreferrer" className="underline">
											progressive.com/annualreport
										</a>
										.
									</p>
									<p className="">
										Our 2025 Proxy Statement and 2024 Annual Report to Shareholders, in a PDF format, can be found at:{' '}
										<a href="https://progressiveproxy.com" target="_blank" rel="noreferrer" className="underline">
											progressiveproxy.com
										</a>
										.
									</p>
								</div>
								<div>
									<h3 className="heading-two text-[#F26721] m-0">Shareholder/Investor Relations</h3>
									<p className="">
										Progressive does not maintain a mailing list for distribution of shareholders’ reports. To view Progressive’s publicly filed documents, shareholders can access our website:{' '}
										<a href="https://progressive.com/sec" target="_blank" rel="noreferrer" className="underline">
											progressive.com/sec
										</a>
										. To view our earnings and other releases, access our website:{' '}
										<a href="https://progressive.com/financial-releases" target="_blank" rel="noreferrer" className="underline">
											progressive.com/financial-releases
										</a>
										.
									</p>
									<p className="">For financial-related information or to request copies of Progressive’s publicly filed documents free of charge, write to: </p>
									<p className="">
										The Progressive Corporation
										<br />
										Investor Relations
										<br />
										300 North Commons Blvd., Box W94
										<br />
										Mayfield Village, Ohio 44143
										<br />
										email:{' '}
										<a href="mailto:investor_relations@progressive.com" className="underline">
											investor_relations@progressive.com
										</a>
										<br />
										or call: 440-395-2222.
									</p>
									<p className="">
										For all other company information, call: 440-461-5000 or access our website at:{' '}
										<a href="https://progressive.com/contactus" target="_blank" rel="noreferrer" className="underline">
											progressive.com/contactus
										</a>
										.
									</p>
								</div>
								<div>
									<h3 className="heading-two text-[#F26721] m-0">Transfer Agent and Registrar</h3>
									<p className="">
										<span className="italic">Registered Shareholders:</span> If you have questions or changes to your account and your Progressive common shares are registered in your name, write to:
									</p>
									<p className="">
										<span className="font-[700]">Equiniti Trust Company, LLC,</span>
										<br />
										48 Wall Street, Floor 23
										<br />
										New York, New York 10005
										<br />
										phone: 1-866-709-7695
										<br />
										email:{' '}
										<a href="mailto:HelpAST@equiniti.com" className="underline">
											HelpAST@equiniti.com
										</a>
										<br />
										or visit their website at:{' '}
										<a href="https://equiniti.com/us" target="_blank" rel="noreferrer" className="underline">
											equiniti.com/us
										</a>
									</p>
									<p className="">
										<span className="italic">Beneficial Shareholders:</span> If your Progressive common shares are held in a brokerage or other financial institution account, contact your broker or financial institution directly regarding questions or changes to your account.
									</p>
								</div>
							</div>
						</div>
						<div className="ml-auto max-w-[584px] mt-auto">
							<div>
								<InlineClippedImage
									src={Corner_Conference_9x12_300}
									alt="Art"
									dimensions={{
										width: 1729,
										height: 1296,
									}}
									clipPaths={[
										{
											initial: {
												x: '17%',
												y: '37%',
												width: '32%',
											},
											expanded: {
												x: '0%',
												y: '0%',
												width: '100%',
											},
										},
									]}
								/>
							</div>
						</div>
					</div>
					<div className="max-w-[550px] flex flex-col gap-6">
						<div className="gap-6">
							<h3 className="heading-two text-[#F26721] m-0">Common Shares, Holders, and Dividends</h3>
							<p className="">
								The Progressive Corporation’s common shares are traded on the New York Stock Exchange (symbol PGR). There were 1,614 shareholders of record on January 31, 2025. Progressive currently has a dividend policy under which the Board expects to declare regular, quarterly common share dividends and, on at least an annual basis, to consider declaring an additional variable common share dividend. The dividend policy can be found at:{' '}
								<a href="https://progressive.com/dividend" target="_blank" rel="noreferrer" className="underline">
									progressive.com/dividend
								</a>
								.
							</p>
						</div>

						<div>
							<h3 className="heading-two text-[#F26721] m-0">Counsel</h3>
							<p className="">Baker & Hostetler LLP, Cleveland, Ohio</p>
						</div>

						<div>
							<h3 className="heading-two text-[#F26721] m-0">Corporate Governance</h3>
							<p className="">
								Progressive’s Corporate Governance Guidelines and Board Committee Charters are available at:{' '}
								<a href="https://progressive.com/governance" target="_blank" rel="noreferrer" className="underline">
									progressive.com/governance
								</a>
								.
							</p>
						</div>
						<div>
							<h3 className="heading-two text-[#F26721] m-0">Accounting Complaint Procedure</h3>
							<p className="">Any employee or other interested party with a complaint or concern regarding accounting, internal accounting controls, or auditing matters relating to Progressive may report such complaint or concern directly to the Chairperson of the Audit Committee, as follows:</p>

							<p className="">
								Stuart B. Burgdoerfer, Chair of the Audit Committee,{' '}
								<a href="mailto:auditchair@progressive.com" className="underline">
									auditchair@progressive.com
								</a>
								.
							</p>

							<p className="">
								Any such complaint or concern also may be reported anonymously over the following toll-free Alertline: 1-800-683-3604 or online at:{' '}
								<a href="https://progressivealertline.com" target="_blank" rel="noreferrer" className="underline">
									progressivealertline.com
								</a>
								.
							</p>

							<p className="">
								Progressive will not retaliate against any individual by reason of his or her having made such a complaint or reported such a concern in good faith. View the complete procedures at:{' '}
								<a href="https://progressive.com/governance" target="_blank" rel="noreferrer" className="underline">
									progressive.com/governance
								</a>
								.
							</p>
						</div>

						<div>
							<h3 className="heading-two text-[#F26721] m-0">Contact Non-Management Directors</h3>
							<p className="">Interested parties have the ability to contact the non-management directors as a group by sending a written communication clearly addressed to the non-management directors to either of the following:</p>
							<p className="">
								Lawton W. Fitt
								<br />
								Chairperson of the Board
								<br />
								The Progressive Corporation
								<br />
								email:{' '}
								<a href="mailto:chair@progressive.com" className="underline">
									chair@progressive.com
								</a>
							</p>
							<p className="">
								David M. Stringer
								<br />
								Secretary
								<br />
								The Progressive Corporation
								<br />
								300 North Commons Blvd., Box W94
								<br />
								Mayfield Village, Ohio 44143
								<br />
								or email:{' '}
								<a href="mailto:secretary@progressive.com" className="underline">
									secretary@progressive.com
								</a>
							</p>
							<p className="">The recipient will forward communications so received to the non-management directors.</p>
						</div>

						<div>
							<h3 className="heading-two text-[#F26721] m-0">Whistleblower Protections</h3>
							<p className="">
								Progressive will not retaliate against any officer or employee of Progressive because of any lawful act done by the officer or employee to provide information or otherwise assist in investigations regarding conduct that the officer or employee reasonably believes to be a violation of federal securities laws or of any rule or regulation of the Securities and Exchange Commission. View the complete Whistleblower Protections at:{' '}
								<a href="https://progressive.com/governance" target="_blank" rel="noreferrer" className="underline">
									progressive.com/governance
								</a>
								.
							</p>
						</div>

						<div>
							<h3 className="heading-two text-[#F26721] m-0">Social Responsibility and Sustainability</h3>
							<p className="">
								Progressive uses an online format to communicate our social responsibility efforts, and we see sustainability as part of the value we bring to our shareholders, customers, employees, agents, and communities. Information on our social responsibility and sustainability efforts can be found at:{' '}
								<a href="https://progressive.com/sustainability" target="_blank" rel="noreferrer" className="underline">
									progressive.com/sustainability
								</a>{' '}
								.
							</p>
						</div>

						<div>
							<h3 className="heading-two text-[#F26721] m-0">Charitable Contributions</h3>
							<p className="">We contribute to: (i) The Insurance Institute for Highway Safety to further its work in reducing the human trauma and economic costs of auto accidents; (ii) Humble Design, a nonprofit organization we partnered with to furnish homes for families and veterans transitioning from homelessness; (iii) Family Promise, a nonprofit organization that helps families experiencing homelessness and low-income families achieve sustainable independence through a community-based response; and (iv) The Progressive Insurance Foundation.</p>
							<p className="">To more broadly represent our employees and their communities, The Progressive Insurance Foundation provides funds to national charitable organizations identified by our Employee Resource Groups and, through the Name Your Cause® program, to qualifying charities chosen by each participating employee’s recommendation, without requiring the employee to contribute. Over the last five years, The Progressive Insurance Foundation provided on average approximately $6 million per year to these charitable organizations.</p>
						</div>
					</div>
				</div>
			</div>

			<Section backgroundColor="#4B7B9D" textColor="#fff" className="py-12 md:py-32">
				<div className="w-full max-w-[100vw]">
					<div className="container max-w-container-lg">
						<h2 className="mb-8 heading-one">
							Insurance Quotes, Claims Reporting,
							<br /> and Customer Service
						</h2>
						<div className="overflow-x-auto">
							<table className="w-full text-right align-top border-r is-styled-table leading-[165%] min-w-[700px] border-collapse table-auto">
								<tr className="border-b leading-[115%]">
									<th className="w-[70%] border-r">
										<p className="font-bold text-[1.25rem]">
											Personal Autos, Motorcycles,
											<br />
											Recereation Vehicles, Homeowners,
											<br />
											and Renters
										</p>
									</th>
									<th>
										<p className="font-bold text-[1.25rem]">
											Commercial Autos/Trucks,
											<br />
											Business Property, and
											<br /> General Liability
										</p>
									</th>
								</tr>
								<tr className="border-b">
									<td className="border-r">
										<div className="flex justify-between">
											<p className="font-bold text-[1.25rem]">To Receive a Quote</p>
											<p className="text-right">
												1-800-PROGRESSIVE (1-800-776-4737)
												<br />
												<a href="https://www.progressive.com/" target="_blank" rel="noreferrer" className="underline">
													progressive.com
												</a>
											</p>
										</div>
									</td>
									<td>
										<p className="text-right">
											1-888-806-9598
											<br />
											<a href="https://progressivecommercial.com" target="_blank" rel="noreferrer" className="underline">
												progressivecommercial.com
											</a>
										</p>
									</td>
								</tr>
								<tr className="border-b">
									<td className="border-r">
										<div className="flex justify-between">
											<p className="font-bold text-[1.25rem]">To Report a Claim</p>
											<p className="text-right">
												1-800-PROGRESSIVE (1-800-776-4737)
												<br />
												<a href="https://progressive.com" target="_blank" rel="noreferrer" className="underline">
													progressive.com
												</a>
											</p>
										</div>
									</td>
									<td>
										<p className="text-right">
											1-888-502-8330
											<br />
											<a href="https://progressivecommercial.com" target="_blank" rel="noreferrer" className="underline">
												progressivecommercial.com
											</a>
										</p>
									</td>
								</tr>
								<tr className="border-b">
									<td className="border-r">
										<div className="flex justify-between">
											<p className="w-[40%] text-left">
												<span className="font-bold text-[1.25rem]">For Customer Service</span>
												<br />
												If you bought your policy directly through Progressive online or by phone
											</p>
											<p className="text-right">
												1-800-PROGRESSIVE (1-800-776-4737)
												<br />
												<a href="https://progressive.com" target="_blank" rel="noreferrer" className="underline">
													progressive.com
												</a>
											</p>
										</div>
									</td>
									<td>
										<p className="text-right">
											1-800-444-4487
											<br />
											<a href="https://progressivecommercial.com" target="_blank" rel="noreferrer" className="underline">
												progressivecommercial.com
											</a>
										</p>
									</td>
								</tr>
								<tr className="border-b">
									<td className="border-r">
										<div className="flex justify-between">
											<p className="w-[40%] text-left">If you bought your policy through an independent agent or broker</p>
											<p className="text-right">
												1-800-925-2886
												<br />
												1-800-300-3693 in California
												<br />
												<a href="https://progressiveagent.com/" target="_blank" rel="noreferrer" className="underline">
													progressiveagent.com
												</a>
											</p>
										</div>
									</td>
									<td>
										<p className="text-right">
											1-800-444-4487
											<br />
											<a href="https://progressivecommercial.com" target="_blank" rel="noreferrer" className="underline">
												progressivecommercial.com
											</a>
										</p>
									</td>
								</tr>
								<tr className="border-b">
									<td className="border-r">
										<div className="flex justify-between">
											<p className="w-[40%] text-left">If you bought your policy through an independent agent or broker for the state of California</p>
											<p className="text-right">
												1-800-300-3693
												<br />
												<a href="https://Driveinsurance.com" target="_blank" rel="noreferrer" className="underline">
													Driveinsurance.com
												</a>
											</p>
										</div>
									</td>
									<td>
										<p className="text-right">
											1-800-444-4487
											<br />
											<a href="https://progressivecommercial.com" target="_blank" rel="noreferrer" className="underline">
												progressivecommercial.com
											</a>
										</p>
									</td>
								</tr>
							</table>
						</div>
						<p className="m-0">In addition, iPhone® and Android® users can download the Progressive App to start a quote, report a claim, or service a policy.</p>
					</div>
				</div>
			</Section>
		</>
	);
};

export default ShareholderInformation;
